<template>
  <coming-soon></coming-soon>
</template>

<script>
import ComingSoon from '@vue-app/components/base/info/ComingSoon.vue'
export default {
  name: 'PayoutsToIban',
  components: { ComingSoon },
}
</script>
